module.exports = __webpack_public_path__ + "resource/img/password.3cf3b035.png";